import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';

const VisionMultimodalTechStack = () => {
    return (
        <div className="overflow-x-hidden border-b section-py bg-grey dark:bg-black"
        style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container mx-auto xl:container">
                <div className="grid mb-11 row lg:grid-cols-12">
                    <div className="text-center lg:col-span-12">
                        <h2 className="dark:text-white">Tech Stack</h2>
                    </div>
                </div>
                <div className="grid overflow-x-hidden row lg:grid-cols-12 technologies-tools-tab">
                    <div className="grid lg:col-span-12">
                        <Tabs.Group className="items-center tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="Frameworks">
                                <div className="grid grid-cols-2 row xl:grid-cols-7 lg:grid-cols-5 md:grid-cols-4">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/pytorch.svg"
                                            className="img-fluid mb-2.5"
                                            alt="PyTorch"
                                            title="PyTorch"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">PyTorch</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                          src="/img/technologies-icon/tensorflow.svg"
                                          className="img-fluid mb-2.5"
                                          alt="TensorFlow"
                                          title="TensorFlow"
                                          height={50}
                                          width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">TensorFlow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-opencv.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OpenCV"
                                            title="OpenCV"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">OpenCV</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/hugging-face.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Hugging Face"
                                            title="Hugging Face"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Hugging Face Transformers</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-yolo.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Ultralytics YOLO"
                                            title="Ultralytics YOLO"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Ultralytics YOLO</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-segment-anything-model.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Segment Anything Model"
                                            title="Segment Anything Model"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Segment Anything Model</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-detectron.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Detectron2"
                                            title="Detectron2"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Detectron2</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Multimodal Models">
                                <div className="grid grid-cols-2 row xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-clip.svg"
                                            className="img-fluid mb-2.5"
                                            alt="CLIP"
                                            title="CLIP"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">CLIP</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-florence.svg"
                                            className="img-fluid mb-2.5 !h-10"
                                            alt="Florence-2"
                                            title="Florence-2"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Florence-2</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-LLaVA.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LLaVA"
                                            title="LLaVA"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">LLaVA</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-BakLLaVA.svg"
                                            className="img-fluid mb-2.5"
                                            alt="BakLLaVA"
                                            title="BakLLaVA"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">BakLLaVA</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-GPT-4-vision.svg"
                                            className="img-fluid mb-2.5"
                                            alt=" GPT-4 Vision"
                                            title=" GPT-4 Vision"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white"> GPT-4 Vision</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-geminivision.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Gemini Vision"
                                            title="Gemini Vision"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Gemini Vision</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Deployment Tools">
                                <div className="grid grid-cols-2 row xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-3">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-onnx-runtime.svg"
                                            className="img-fluid mb-2.5"
                                            alt="ONNX Runtime"
                                            title="ONNX Runtime"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">ONNX Runtime</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-tensorrt.svg"
                                            className="img-fluid mb-2.5"
                                            alt="TensorRT"
                                            title="TensorRT"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">TensorRT</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-openvino.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OpenVINO"
                                            title="OpenVINO"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">OpenVINO</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-awspanorama.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AWS Panorama"
                                            title="AWS Panorama"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">AWS Panorama</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-cognitive.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure Cognitive Services"
                                            title="Azure Cognitive Services"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Azure Cognitive Services</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Data Management">
                                <div className="grid grid-cols-2 row xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-roboflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Roboflow"
                                            title="Roboflow"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Roboflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-cvat.svg"
                                            className="img-fluid mb-2.5"
                                            alt="CVAT"
                                            title="CVAT"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">CVAT</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-labelstudio.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Label Studio"
                                            title="Label Studio"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Label Studio</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Weights-Biases.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Weights & Biases"
                                            title="Weights & Biases"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Weights & Biases</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="MLOps">
                                <div className="grid grid-cols-2 row xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-mlflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="MLflow"
                                            title="MLflow"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">MLflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-kubeflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Kubeflow"
                                            title="Kubeflow"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Kubeflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-docker.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Docker"
                                            title="Docker"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Docker</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-kubernetes.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Kubernetes"
                                            title="Kubernetes"
                                            height={50}
                                            width={50}
                            loading="lazy"
                        />
                        <p className="mb-0 text-base font-semibold dark:text-white">Kubernetes</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default VisionMultimodalTechStack;
